import type { PostSignoutRequest } from './types';
import type { GetSignoutResponse } from '../get';

import { postGenericEndpoint, type PostGenericEndpointParams } from './post.api';

export const postSignout = async ({ data, lang, token }: PostGenericEndpointParams<PostSignoutRequest>): Promise<GetSignoutResponse> => {
    return await postGenericEndpoint({
        data,
        lang,
        token,
        path: 'signout',
    });
};
